<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">
        {{
          $t(
            'school.academic.setup.program.subject.activity_subjects.new_activity_subject'
          )
        }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.program'
                  )
                }}
              </label>
              <div>
                <select class="form-control" :class="{ 'is-invalid': errors.has('acp_id') }" v-model="model.acp_id">
                  <option value>{{ $t('select') }}</option>
                  <option v-for="(p, index) in programs" :key="index" :value="p.acp_id">{{ p.acp_name_foreign }}</option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('acp_id')">
                  {{ errors.first('acp_id') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.sub_program'
                  )
                }}
              </label>
              <div>
                <a-select v-model="model.acps_id" :class="{ 'is-invalid': errors.has('acps_id') }"
                  :options="subPrograms.filter(sp => sp.acp_id == model.acp_id).map(sp => ({ value: sp.acps_id, label: sp.acps_name_foreign }))">
                </a-select>
                <div class="invalid-feedback" v-if="errors.has('acps_id')">
                  {{ errors.first('acps_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.subject_(en)'
                  )
                }}
              </label>
              <div>
                <input class="form-control" v-model="model.subject_name_foreign" :class="{
                  'is-invalid': errors.has('subject_name_foreign')
                }" />
                <div class="invalid-feedback" v-if="errors.has('subject_name_foreign')">
                  {{ errors.first('subject_name_foreign') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.subject_(kh)'
                  )
                }}
              </label>
              <div>
                <input class="form-control" v-model="model.subject_name_native" :class="{
                  'is-invalid': errors.has('subject_name_native')
                }" />
                <div class="invalid-feedback" v-if="errors.has('subject_name_native')">
                  {{ errors.first('subject_name_native') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.subject_code'
                  )
                }}
              </label>
              <div>
                <ts-input class="form-control" v-model="model.subject_code" />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.order'
                  )
                }}
              </label>
              <div>
                <ts-input class="form-control" v-model="model.subject_order" />
                <small class="f-s-12 text-grey-darker" style="font-size: 10px !important;">
                  {{
                    $t(
                      'school.academic.setup.program.subject.activity_subjects.khmer_secondary_progam_only'
                    )
                  }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.display'
                  )
                }}
              </label>
              <div>
                <select class="form-control" v-model="model.display_column"
                  :class="{ 'is-invalid': errors.has('display_column') }">
                  <option :value="1">ខ្មែរ</option>
                  <option :value="2">English</option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('display_column')">
                  {{ errors.first('display_column') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <div class="ts-bg-gray-200 ts-p-2 ts-rounded">
              <div class="d-flex justify-content-between">
                <label class="ts-text-xs">
                  {{
                    $t(
                      'school.academic.setup.program.subject.core_subjects.assessment_components'
                    )
                  }}
                </label>
                <div>
                  <a href="#" v-tooltip="$t('scoreComponent.addMoreComponent')" @click.prevent="addNewComponent">
                    <i class="far fa-plus-square"></i>
                  </a>
                </div>
              </div>
              <table style="width:100%" class="mt-1">
                <draggable tag="tbody" v-model="model.component_list">
                  <tr v-for="(item, index) in model.component_list" :key="index">
                    <td style="padding: 3px 8px 7px 0;">
                      <input v-model.trim="item.comp_item_name" type="text" class="bb" style="width:100%" />
                    </td>
                    <td style="width:10px" valign="top">
                      <a href="#" class="text-danger" @click.prevent="removeItem(index)">
                        <i class="fas fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{
              $t('cancel')
            }}</ts-button>
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="submit">{{ $t('save') }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import draggable from 'vuedraggable'

export default {
  name: 'subject-activity-form',
  props: ['editData', 'programs', 'subPrograms'],
  components: {
    draggable
  },
  data() {
    return {
      model: {
        acp_id: this.editData ? this.editData.acp_id : '',
        acps_id: this.editData ? this.editData.acps_id : '',
        subject_name_native: this.editData
          ? this.editData.subject_name_native
          : '',
        subject_name_foreign: this.editData
          ? this.editData.subject_name_foreign
          : '',
        subject_code: this.editData ? this.editData.subject_code : '',
        subject_order: this.editData ? this.editData.subject_order : '',
        display_column: this.editData ? this.editData.display_column : '',
        component_list:
          this.editData && this.editData.component_list
            ? this.editData.component_list.map(comp => ({
              subject_comp_id: comp.subject_comp_id,
              comp_item_name: comp.comp_item_name,
              display_order: comp.display_order
            }))
            : []
      },
      errors: new Errors(),
      saving: false
    }
  },
  computed: {
    formTitle() {
      return this.editData ? 'Edit activity subject' : 'New activity subject'
    }
  },
  created() { },
  methods: {
    addNewComponent(event) {
      this.model.component_list.push({
        subject_comp_id: 0,
        comp_item_name: event.target.value,
        display_order: this.model.component_list.length
      })
    },
    removeItem(index) {
      this.model.component_list.splice(index, 1)
    },
    submit() {
      let response

      this.errors = new Errors()
      this.saving = true

      if (this.editData) {
        response = this.$store.dispatch('subjectActivity/update', {
          subject_id: this.editData.subject_id,
          ...this.model
        })
      } else {
        response = this.$store.dispatch('subjectActivity/store', this.model)
      }

      response
        .then(response => {
          this.$store.dispatch('subjectActivity/fetch').then(() => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
          })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    'model.acp_id': function () {
      this.model.acps_id = ''
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('subjectActivity/RESET_STATE')
    }
    next()
  }
}
</script>
<style scoped>
.bb {
  border: none;
  outline: none !important;
  padding: 3px 7px;
  border-radius: 5px;
}
</style>
